import { useState } from "react";
import permissionsController from "../../../../../apis/Controllers/PermissionsController/permissions.contoller";
import Validation from "../../../../Helper/validations/vaildation";
import rolesController from "../../../../../apis/Controllers/RolesController/roles.controller";
import { Toaster } from "../../../../Helper/toaster/Toaster";
import { useLocation, useNavigate } from "react-router-dom";
import store from "../../../../../redux/store";
import { all } from "axios";
import roomsController from "../../../../../apis/Controllers/RoomsController/rooms.controller";
import bedsController from "../../../../../apis/Controllers/BedsControoler/beds.controller";
import { useEffect } from "react";

const BedListFunction = () => {

    var breadcrumData = ["Dashboard"];
    const [bedList, setBedList] = useState([])
    const [loader, setLoader] = useState(false);
    const [breadcrumItem, setbreadcrumItem] = useState("Bed List");
    const [deletePopup, setDeletePopup] = useState(false);
    const [deleteItem, setDeleteItem] = useState(null);
    const loaction = useLocation();
    const navigate = useNavigate();
    const [sorting, setSorting] = useState(null);
    // -------------------PAZINATION ----------------------
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState([]);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //-----------------------------------------------------

    useEffect(() => {
        if (count) {
            handlePages(count);
        }
    }, [count]);


    const getBedListing = async (e, page, itemsPerPage, sort) => {
        if (!loader) {
            setLoader(true);
            let post = {
                search: e ? e : '',
                page: page ? page : 1,
                limit: itemsPerPage ? itemsPerPage : 10,
                sort: sort ? sort : null
            };
            let response = await bedsController.superAdminBedsListing(post);
            if (response && response.status) {
                setBedList(response.data);
                setCount(response.count);
                setTotalCount(response.count);
                setLoader(false);
            } else {
                setLoader(false);
                setCount(null);
                setTotalCount(null)
            }
        }
    }

    //--bed--filters------------------->

    const handleFilters = (sort) => {
        if (sort) {
            setSorting(sort)
            getBedListing("", page, itemsPerPage, sort)
        }
    };

    const updateBedStatuss = async (item) => {
        let post = {
            status: item.status == 1 ? 0 : 1,
        };
        let response = await bedsController.updateBedStatus(item.id, post);
        if (response && response.status) {
            new Toaster().success(response.message);
            getBedListing("", page);
        } else return;
    };


    const handleDelete = (item) => {
        setDeleteItem(item)
        setDeletePopup(true)
    };


    const handleDeleteBed = async (data) => {
        let array = [...bedList]
        let id = data && data.id ? data.id : '';
        let response = await bedsController.bedsDelete(id);
        if (response && response.status) {
            new Toaster().success(response.message);
            setDeletePopup(false);
            let filterData = array.filter((data) => data.id !== data.id);
            if (filterData.length > 0) {
                getBedListing('', page, itemsPerPage);
            }
            else {
                if (page > 1) {
                    let newpage = page - 1
                    setPage(page - 1);
                    getBedListing('', newpage, itemsPerPage);
                }
                else {
                    setPage(page);
                    getBedListing('', page, itemsPerPage);
                }
            }
            setTotalPages([]);
        }
        else {
            setDeletePopup(false)
        }
    };

    const handleBackClick = () => {                             //<------------PAZINATION
        if (page > 1) {
            let newpage = page - 1;
            setPage(page - 1);
            getBedListing("", newpage);
        } else {
            setPage(1);
            getBedListing("", 1);
        }
    };

    const handleNextClick = () => {                                 //<------------PAZINATION
        if (page >= 1 && page < totalPages.length) {
            let newpage = page + 1;
            setPage(page + 1);
            getBedListing("", newpage);
        } else {
            setPage(page);
            getBedListing("", page);
        }
    };

    const handlePage = (e) => {
        setPage(e);
        getBedListing("", e);
    };

    const handlePages = (count) => {
        let array = [];
        const data = parseInt(count);
        const totalPage = Math.ceil(data / itemsPerPage);
        for (let i = 1; i <= totalPage; i++) {
            array.push(i);
        }
        setTotalPages(array);
    };


    const handleBreadcrumDataNaviagtion = (i) => {
        let user = store.getState().UserReducer.user;
        if (i === 0) {
            if (user && parseInt(user.user_type) === 0) {
                navigate("/dashboard");
            } else {
                navigate("/dashboard-superadmin");
            }
        } else if (i === 1) {
            navigate("/bed-list");
        } else return;
    };



    return {
        getBedListing,
        breadcrumData,
        loader,
        breadcrumItem,
        loaction,
        bedList,
        navigate,
        handleDelete,
        deletePopup,
        deleteItem,
        handleDeleteBed,
        setDeletePopup,
        handleBackClick,
        handleNextClick,
        handlePage,
        handleBreadcrumDataNaviagtion,
        totalCount,
        page,
        totalPages,
        handleFilters,
        sorting,
        handlePages,
        updateBedStatuss
    };
};

export default BedListFunction;
